"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AkordApi = exports.defaultFileUploadOptions = void 0;
const api_1 = require("./api");
const config_1 = require("./config");
const api_client_1 = require("./api-client");
const logger_1 = require("../logger");
const node_1 = require("../types/node");
const stream_converter_1 = require("../util/stream-converter");
exports.defaultFileUploadOptions = {
    storage: node_1.StorageType.ARWEAVE,
    public: false
};
const RETRY_MAX = 3;
const RETRY_AFTER = 1000;
class AkordApi extends api_1.Api {
    constructor(config) {
        super();
        this.config = (0, config_1.apiConfig)(config.env);
    }
    uploadData(items, cloud = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const resources = [];
            yield Promise.all(items.map((item, index) => __awaiter(this, void 0, void 0, function* () {
                const resource = yield new api_client_1.ApiClient()
                    .env(this.config)
                    .tags(item.tags)
                    .state(item.data)
                    .cloud(cloud)
                    .uploadState();
                logger_1.Logger.log("Uploaded state with id: " + resource);
                resources[index] = resource;
            })));
            return resources;
        });
    }
    ;
    postContractTransaction(vaultId, input, tags, metadata) {
        return __awaiter(this, void 0, void 0, function* () {
            let retryCount = 0;
            let lastError;
            while (retryCount < RETRY_MAX) {
                try {
                    const { id, object } = yield new api_client_1.ApiClient()
                        .env(this.config)
                        .vaultId(vaultId)
                        .metadata(metadata)
                        .input(input)
                        .tags(tags)
                        .transaction();
                    logger_1.Logger.log("Uploaded contract interaction with id: " + id);
                    return { id, object };
                }
                catch (error) {
                    lastError = error;
                    logger_1.Logger.log(error);
                    logger_1.Logger.log(error.message);
                    yield new Promise(r => setTimeout(r, RETRY_AFTER));
                    logger_1.Logger.log("Retrying...");
                    retryCount++;
                    logger_1.Logger.log("Retry count: " + retryCount);
                }
            }
            logger_1.Logger.log(`Request failed after ${RETRY_MAX} attempts.`);
            throw lastError;
        });
    }
    ;
    getMembers(vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new api_client_1.ApiClient()
                .env(this.config)
                .vaultId(vaultId)
                .getMembers();
        });
    }
    ;
    initContractId(tags, state) {
        return __awaiter(this, void 0, void 0, function* () {
            const contractId = yield new api_client_1.ApiClient()
                .env(this.config)
                .tags(tags)
                .state(state)
                .contract();
            logger_1.Logger.log("Created contract with id: " + contractId);
            return contractId;
        });
    }
    ;
    uploadFile(file, tags, options = exports.defaultFileUploadOptions) {
        return __awaiter(this, void 0, void 0, function* () {
            const uploadOptions = Object.assign(Object.assign({}, exports.defaultFileUploadOptions), options);
            const resource = yield new api_client_1.ApiClient()
                .env(this.config)
                .data(file)
                .tags(tags)
                .public(uploadOptions.public)
                .storage(uploadOptions.storage)
                .progressHook(uploadOptions.progressHook)
                .cancelHook(uploadOptions.cancelHook)
                .uploadFile();
            logger_1.Logger.log("Uploaded file with uri: " + resource.resourceUri);
            return resource;
        });
    }
    ;
    getUploadState(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const resource = yield new api_client_1.ApiClient()
                    .env(this.config)
                    .resourceId(id)
                    .getUploadState();
                return resource;
            }
            catch (error) {
                return null; // upload state not saved yet
            }
        });
    }
    ;
    downloadFile(id, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const { response } = yield new api_client_1.ApiClient()
                .env(this.config)
                .resourceId(id)
                .public(options.public)
                .progressHook(options.progressHook)
                .cancelHook(options.cancelHook)
                .downloadFile();
            let fileData;
            if (options.responseType === 'arraybuffer') {
                fileData = yield response.arrayBuffer();
            }
            else {
                if (response.body.getReader) {
                    fileData = response.body;
                }
                else {
                    fileData = stream_converter_1.StreamConverter.fromAsyncIterable(response.body);
                }
            }
            const metadata = {
                encryptedKey: response.headers.get("x-amz-meta-encrypted-key") || response.headers.get("x-amz-meta-encryptedkey"),
                iv: response.headers.get("x-amz-meta-initialization-vector") || response.headers.get("x-amz-meta-iv")
            };
            return { fileData, metadata };
        });
    }
    ;
    existsUser(email) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new api_client_1.ApiClient()
                .env(this.config)
                .queryParams({ email })
                .existsUser();
        });
    }
    getUserPublicData(email) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new api_client_1.ApiClient()
                .env(this.config)
                .queryParams({ email })
                .getUserPublicData();
        });
    }
    ;
    getUser() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new api_client_1.ApiClient()
                .env(this.config)
                .getUser();
        });
    }
    ;
    updateUser(name, avatarUri) {
        return __awaiter(this, void 0, void 0, function* () {
            yield new api_client_1.ApiClient()
                .env(this.config)
                .data({
                name: name,
                avatarUri: avatarUri
            })
                .updateUser();
        });
    }
    ;
    deleteVault(vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield new api_client_1.ApiClient()
                .env(this.config)
                .vaultId(vaultId)
                .deleteVault();
        });
    }
    inviteNewUser(vaultId, email, role, message) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new api_client_1.ApiClient()
                .env(this.config)
                .vaultId(vaultId)
                .data({
                email: email,
                role: role
            })
                .metadata({ message })
                .invite();
        });
    }
    revokeInvite(vaultId, membershipId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new api_client_1.ApiClient()
                .env(this.config)
                .vaultId(vaultId)
                .resourceId(membershipId)
                .revokeInvite();
        });
    }
    inviteResend(vaultId, membershipId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new api_client_1.ApiClient()
                .env(this.config)
                .vaultId(vaultId)
                .resourceId(membershipId)
                .inviteResend();
        });
    }
    getNode(id, type) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new api_client_1.ApiClient()
                .env(this.config)
                .resourceId(id)
                .queryParams({ type })
                .getNode();
        });
    }
    ;
    getMembership(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new api_client_1.ApiClient()
                .env(this.config)
                .resourceId(id)
                .getMembership();
        });
    }
    ;
    getVault(id, options) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new api_client_1.ApiClient()
                .env(this.config)
                .resourceId(id)
                .queryParams({
                withNodes: options === null || options === void 0 ? void 0 : options.withNodes,
                withMemberships: options === null || options === void 0 ? void 0 : options.deep,
                withMemos: options === null || options === void 0 ? void 0 : options.deep,
                withStacks: options === null || options === void 0 ? void 0 : options.deep,
                withFolders: options === null || options === void 0 ? void 0 : options.deep,
            })
                .getVault();
        });
    }
    ;
    getMembershipKeys(vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new api_client_1.ApiClient()
                .env(this.config)
                .vaultId(vaultId)
                .getMembershipKeys();
        });
    }
    ;
    getNodeState(stateId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new api_client_1.ApiClient()
                .env(this.config)
                .resourceId(stateId)
                .downloadState();
        });
    }
    ;
    getContractState(objectId) {
        return __awaiter(this, void 0, void 0, function* () {
            const contract = yield new api_client_1.ApiClient()
                .env(this.config)
                .vaultId(objectId)
                .getContract();
            return contract.state;
        });
    }
    ;
    getMemberships(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new api_client_1.ApiClient()
                .env(this.config)
                .queryParams({
                limit: options.limit,
                nextToken: options.nextToken
            })
                .getMemberships();
        });
    }
    ;
    getVaults(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new api_client_1.ApiClient()
                .env(this.config)
                .queryParams({
                tags: JSON.stringify(options.tags ? options.tags : {}),
                filter: JSON.stringify(options.filter ? options.filter : {}),
                limit: options.limit,
                nextToken: options.nextToken
            })
                .getVaults();
        });
    }
    ;
    getNodesByVaultId(vaultId, type, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new api_client_1.ApiClient()
                .env(this.config)
                .vaultId(vaultId)
                .queryParams({
                type,
                parentId: options.parentId,
                tags: JSON.stringify(options.tags ? options.tags : {}),
                filter: JSON.stringify(options.filter ? options.filter : {}),
                limit: options.limit,
                nextToken: options.nextToken
            })
                .getNodesByVaultId();
        });
    }
    ;
    getMembershipsByVaultId(vaultId, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new api_client_1.ApiClient()
                .env(this.config)
                .vaultId(vaultId)
                .queryParams({
                filter: JSON.stringify(options.filter ? options.filter : {}),
                limit: options.limit,
                nextToken: options.nextToken
            })
                .getMembershipsByVaultId();
        });
    }
    ;
    getTransactions(vaultId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new api_client_1.ApiClient()
                .env(this.config)
                .vaultId(vaultId)
                .getTransactions();
        });
    }
    getTransactionTags(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield new api_client_1.ApiClient()
                .env(this.config)
                .resourceId(id)
                .getTransactionTags();
        });
    }
}
exports.default = AkordApi;
exports.AkordApi = AkordApi;
